module.exports = __webpack_public_path__ + "static/media/login-img.e3438b9d.jpg";